var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowCurvedOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 70,
    viewBox: "0 0 173 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.35273 1.47201C0.440798 9.19111 11.535 32.1114 18.4726 38.3566C36.7999 54.8549 62.9629 65.8326 85.2406 59.8181C88.8291 58.8488 95.5717 55.7302 98.5031 53.4098C123.864 33.3186 74.3255 9.56274 73.37 39.6966C73.26 43.1708 74.734 47.362 76.5805 50.3144C91.2867 73.8273 130.661 69.6582 150.348 65.6319C155.04 64.6731 167.74 62.5274 169.902 56.8271C170.038 56.4734 166.901 62.1424 164.486 63.8505C163.932 64.2419 162.201 64.8439 162.874 65.1035C164.911 65.8892 172.519 60.8304 171.657 58.0388C171.31 56.9158 161.476 57.1333 160.571 56.9804",
    stroke: "#4CB963",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCurvedOut);
export default __webpack_public_path__ + "static/media/arrow-curved-out.3fa53eaac6f33f0be4d71e92ba352dfc.svg";
export { ForwardRef as ReactComponent };